export default __webpack_public_path__ + "static/media/tutorial-02.41423400.png";